import { render, staticRenderFns } from "./HeaderContent.vue?vue&type=template&id=56b8696e&scoped=true&lang=pug&"
import script from "./HeaderContent.vue?vue&type=script&lang=js&"
export * from "./HeaderContent.vue?vue&type=script&lang=js&"
import style0 from "./HeaderContent.vue?vue&type=style&index=0&id=56b8696e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b8696e",
  null
  
)

export default component.exports